import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import * as _ from 'lodash';

import { MediaModel } from '../../models/MediaModel';
import { TypeMediaModel } from '../../models/TypeMediaModel';
import { MediaApiService } from '../../web-api-services/media.service';
import { NotificationService } from '../../services/notification.service';
import { CacheService } from '../../services/cache-service';
import { MediaService } from '../../services/media.service';

@Component({
  selector: 'upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css'],
})
export class UploadComponent implements OnInit {
  @Input() editMode: boolean = true;
  private _mediaId: number;

  @Input() maxHeight: string = '200px';
  @Input() maxWidth: string = '200px';

  @Input() mediaUrl: string;
  @Input()
  set mediaId(value: number) {
    this._mediaId = value;
    // Load Media
    if (this._mediaId) {
      this.mediaApiService.getMedia(this._mediaId).subscribe(media => {
        this.media = media;
      });
    } else {
      this.media = null;
    }
  }
  get mediaId(): number {
    return this._mediaId;
  }

  private _typeMediaId: number;
  @Input()
  set typeMediaId(value: number) {
    this._typeMediaId = value;
    // Load Media
    if (this._typeMediaId) {
      this.cacheService.getTypeMedia(this._typeMediaId).subscribe(typeMedia => {
        this.typeMedia = typeMedia;
        this.texteAjout = this.typeMedia.TexteAjout;
        this.texteSuppression = this.typeMedia.TexteSuppression;
        this.accept = this.typeMedia.FormatAccepte;
        this.texteAideFormat = this.typeMedia.TexteAideFormat;
        this.texteAvertissement = this.typeMedia.TexteAvertissement;
      });
    } else {
      this.typeMedia = null;
      this.texteAjout = 'Télécharger un fichier';
      this.texteSuppression = 'Supprimer le fichier';
      this.accept = 'image/png, image/jpeg';
      this.texteAideFormat = null;
      this.texteAvertissement = null;
    }
  }
  get typeMediaId(): number {
    return this._typeMediaId;
  }
  texteAjout: string = 'Télécharger un fichier';
  texteSuppression: string = 'Supprimer le fichier';
  accept: string = 'image/png, image/jpeg';
  texteAideFormat: string = null;
  texteAvertissement: string = null;
  newFichier: FichierModelName = <FichierModelName>{};
  delFichier: FichierModelName = <FichierModelName>{};

  @Output() mediaIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() mediaUrlChange: EventEmitter<string> = new EventEmitter<string>();
  media: MediaModel;
  typeMedia: TypeMediaModel;

  @Input() isLogo: boolean = true;

  @Input() listeFichier: FichierModelName[] = [];

  // displayZoom: boolean = false;

  constructor(
    private http: HttpClient,
    private mediaApiService: MediaApiService,
    private notificationService: NotificationService,
    private cacheService: CacheService,
    private mediaService: MediaService,
  ) {}

  ngOnInit() {}

  public deleteFile() {
    this.media = null;
    this.mediaIdChange.emit(null);
    this.mediaUrlChange.emit(null);

    //On enlève le fichier de la liste renvoyée
    this.delFichier.infoFichier = this.media;
    let i = this.listeFichier.indexOf(this.delFichier);
    this.listeFichier.splice(i, 1);
  }

  public uploadFile(files) {
    if (files.length === 0) {
      return;
    }
    let fileToUpload = <File>files[0];

    this.mediaService.uploadMedia(this._typeMediaId, fileToUpload).subscribe(
      media => {
        if (media.Erreur) {
          this.notificationService.error(media.Erreur);
        } else if (media.Media) {
          this.media = media.Media;
          this.mediaIdChange.emit(this.media.Id);
          this.mediaUrlChange.emit(this.media.Url);
          //On ajoute le fichier dans la liste, en récupérant le nom.extention
          this.newFichier;
          this.newFichier.infoFichier = this.media;
          this.newFichier.nomFichier = this.media.Nom + '.' + this.media.Url.split(/[#?]/)[0].split('.').pop().trim();
          this.listeFichier.push(this.newFichier);
          this.newFichier = <FichierModelName>{};
          console.log(this.listeFichier);
        }
      },
      error => {
        this.notificationService.error('Une erreur est survenue lors du téléchargement du fichier.');
      },
    );

    //const formData = new FormData();
    //formData.append('file', fileToUpload, fileToUpload.name);
    //var url = `api/Media?mediaType=${this._typeMediaId}`;
    //this.http.post<MediaViewModel>(url, formData)
    //  .subscribe(
    //    media => {
    //      if (media.Erreur) {
    //        this.notificationService.error(media.Erreur);
    //      }
    //      else if (media.Media) {
    //        this.media = media.Media;
    //        this.mediaIdChange.emit(this.media.Id);
    //        this.mediaUrlChange.emit(this.media.Url);

    //        //On ajoute le fichier dans la liste, en récupérant le nom.extention

    //        this.newFichier;
    //        this.newFichier.infoFichier = this.media;
    //        this.newFichier.nomFichier = this.media.Nom+"."+this.media.Url.split(/[#?]/)[0].split('.').pop().trim();
    //        this.listeFichier.push(this.newFichier);
    //        this.newFichier = <FichierModelName>{};
    //        console.log(this.listeFichier);
    //      }
    //    },
    //    error => {
    //      this.notificationService.error("Une erreur est survenue lors du téléchargement du fichier.");
    //    }
    //);

    //this.http.post(url, formData, { reportProgress: true, observe: 'events' })
    //  .subscribe(event => {
    //    if (event.type === HttpEventType.UploadProgress) {
    //      // this.progress = Math.round(100 * event.loaded / event.total);
    //    }
    //    else if (event.type === HttpEventType.Response) {
    //      // this.message = 'Upload success.';
    //      this.onUploadFinished.emit(event.body);
    //    }
    //  });
  }
}

interface FichierModelName {
  infoFichier: MediaModel;
  nomFichier: string;
}
